import { render, staticRenderFns } from "./ParametresDaf.vue?vue&type=template&id=9d933fac"
import script from "./ParametresDaf.vue?vue&type=script&lang=js"
export * from "./ParametresDaf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports